import(/* webpackMode: "eager" */ "/Users/saif-dc/Dcastalia/Node JS Projects/ucb/components/contact/AllContact.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/saif-dc/Dcastalia/Node JS Projects/ucb/components/openAccount/Video.jsx");
